howspace.passkeys = (() => {
    'use strict';

    // copied from https://github.com/github/webauthn-json/blob/main/src/webauthn-json/base64url.ts
    const base64urlToBuffer = baseurl64String => {
        const padding = "==".slice(0, (4 - baseurl64String.length % 4) % 4);
        const base64String = baseurl64String.replace(/-/g, "+").replace(/_/g, "/") + padding;
        const str = atob(base64String);
        const buffer = new ArrayBuffer(str.length);
        const byteView = new Uint8Array(buffer);
        for (let i = 0; i < str.length; i++) {
            byteView[i] = str.charCodeAt(i);
        }
        return buffer;
    }

    // copied from https://github.com/github/webauthn-json/blob/main/src/webauthn-json/base64url.ts
    const bufferToBase64url = buffer => {
        const byteView = new Uint8Array(buffer);
        let str = "";
        for (const charCode of byteView) {
            str += String.fromCharCode(charCode);
        }
        const base64String = btoa(str);
        return base64String.replace(/\+/g, "-").replace(/\//g, "_").replace(/=/g, "");
    }

    const decodeCreationOptions = options => {
        options.challenge = base64urlToBuffer(options.challenge);
        options.user.id = base64urlToBuffer(options.user.id);

        if (options.excludeCredentials) {
            for (const credential of options.excludeCredentials) {
                credential.id = base64urlToBuffer(credential.id);
            }
        }

        return options;
    };

    const encodeCreationCredential = credential => {
        return JSON.stringify({
            authenticatorAttachment: credential.authenticatorAttachment,
            id: credential.id,
            rawId: bufferToBase64url(credential.rawId),
            response: {
                attestationObject: bufferToBase64url(credential.response.attestationObject),
                clientDataJSON: bufferToBase64url(credential.response.clientDataJSON)
            },
            type: credential.type
        });
    };

    const createCredential = async (successFn, errorFn) => {
        // get registration options from the server
        real.ajax.json(real.baseUri + '/api/webauthn/registeroptions', {
            type : 'GET',
            error : errorFn,
            success : async function (response) {
                const handleSuccess = function(credential) {
                    // post the new credentials back to the server
                    real.ajax.json(real.baseUri + '/api/webauthn/register', {
                        type: 'POST',
                        data: encodeCreationCredential(credential),
                        showErrorNotification : false,
                        success : successFn,
                        error : errorFn
                    });
                };

                const handleFailure = function(error) {
                    console.log(error);
                    errorFn();
                };

                // ask the browser to create new credentials
                await navigator.credentials.create({
                    publicKey: decodeCreationOptions(response)
                }).then(handleSuccess).catch(handleFailure);
            }
        });
    };

    const deleteCredential = (webauthnCredentialId, successFn, errorFn) => {
        real.ajax.json(real.baseUri + '/api/webauthncredential/' + webauthnCredentialId, {
            type: 'DELETE',
            success: successFn,
            error: errorFn
        });
    };

    const decodeRequestOptions = options => {
        options.challenge = base64urlToBuffer(options.challenge);

        if (options.allowCredentials) {
            for (const credential of options.allowCredentials) {
                credential.id = base64urlToBuffer(credential.id);
            }
        }

        return options;
    };

    const encodeRequestCredentials = credential => {
        return JSON.stringify({
            authenticatorAttachment: credential.authenticatorAttachment,
            id: credential.id,
            rawId: bufferToBase64url(credential.rawId),
            response: {
                authenticatorData: bufferToBase64url(credential.response.authenticatorData),
                clientDataJSON: bufferToBase64url(credential.response.clientDataJSON),
                signature: bufferToBase64url(credential.response.signature),
                userHandle: bufferToBase64url(credential.response.userHandle)
            },
            type: credential.type
        });
    };

    const handleLoginSuccess = (credential, errorFn) => {
        // post the login credentials back to the server
        real.ajax.json(real.baseUri + '/api/webauthn/login', {
            type: 'POST',
            data: encodeRequestCredentials(credential),
            showErrorNotification : false,
            success : function (response) {
                window.location = response.login_link_url;
            },
            error : errorFn
        });
    }

    const conditionalLogin = async errorFn => {
        if (window.PublicKeyCredential && PublicKeyCredential.isConditionalMediationAvailable) {
            const isCMA = await PublicKeyCredential.isConditionalMediationAvailable();
            if (isCMA) {
                // create temporary login challenge
                real.ajax.json(real.baseUri + '/api/webauthn/conditionalloginoptions', {
                    type: 'GET',
                    error: errorFn,
                    success: async function (response) {
                        const abortController = new AbortController();

                        const handleSuccess = function (credential) {
                            handleLoginSuccess(credential, errorFn);
                        }

                        const handleFailure = function(error) {
                            console.log(error);
                            errorFn();
                        };

                        // ask browser to fulfill temporary login challenge with conditional mediation
                        await navigator.credentials.get({
                            publicKey: decodeRequestOptions(response),
                            signal: abortController.signal,
                            mediation: 'conditional'
                        }).then(handleSuccess).catch(handleFailure);
                    }
                });
            }
        }
    };

    const optOut = () => {
        real.ajax.json(real.baseUri + '/api/webauthn/optout', {
            type: 'POST',
            showErrorNotification : false
        });
    };

    return {
        createCredential: createCredential,
        deleteCredential: deleteCredential,
        conditionalLogin: conditionalLogin,
        optOut: optOut,
    };
})();
